{
  "welcome": {
    "title": "Welcome to",
    "subtitle": "Your AI-powered fitness companion. Get personalized workouts, nutrition plans, and expert guidance.",
    "heading": "Welcome back",
    "description": "Sign in to access your workouts, track your progress, and reach your fitness goals."
  },
  "cta": {
    "title": "Ready to get started?",
    "subtitle": "Join thousands of users transforming their fitness journey with AI."
  },
  "buttons": {
    "signIn": "Sign In",
    "signUp": "Sign Up",
    "signUpFree": "Sign Up Free",
    "learnMore": "Learn More",
    "authenticate": "Authenticate"
  },
  "trust": {
    "subtitle": "Trusted by fitness enthusiasts worldwide",
    "badges": {
      "ai": "AI",
      "fit": "FIT",
      "smart": "SMART"
    }
  },
  "footer": {
    "copyright": "© 2025 Fytness. All rights reserved.",
    "privacyPolicy": "Privacy Policy",
    "termsOfService": "Terms of Service",
    "contact": "Contact",
    "redirectNotice": "You will be redirected to sign in via your browser"
  },
  "brand": {
    "name": "Fytness",
    "tagline": "Your fitness companion"
  }
}
